export const shortUrlDeeplinkUrlPrefix = "https://app.totely.in/" 